import config from '../config';
import {fetchHelper, setToken, simulateDelay} from '../utils/requestUtils';

export async function submitLogin(username, password) {
    await simulateDelay();
    const response = await fetchHelper({
        method: "POST",
        url: "/users/login",
        reqBody:{username, password}
    })
    
    // Check if 2FA setup is required
    if (response.requires_setup) {
        return {
            requires_setup: true,
            requires_2fa: false,
            username: response.username
        };
    }
    
    // Check if 2FA verification is required
    if (response.requires_2fa) {
        return {
            requires_setup: false,
            requires_2fa: true,
            username: response.username
        };
    }
    
    // // Normal login - set token and return
    // setToken(response)
    // return {
    //     requires_2fa: false,
    //     requires_setup: false
    // };
}

export async function verify2FA(username, code) {
    await simulateDelay();
    const response = await fetchHelper({
        method: "POST",
        url: "/users/verify2fa",
        reqBody:{username, code}
    })
    setToken(response)
    return response
}

export async function generate2FASetup(username) {
    await simulateDelay();
    const response = await fetchHelper({
        method: "POST",
        url: "/users/generate2fa",
        reqBody:{username}
    })
    return response
}

export async function complete2FASetup(username, secret, code) {
    await simulateDelay();
    const response = await fetchHelper({
        method: "POST",
        url: "/users/complete2fa",
        reqBody:{username, secret, code}
    })
    setToken(response)
    return response
}

export async function submitLogout() {
    await simulateDelay();
    try {
        document.cookie = `jsonWebToken=${''}`;
        location.replace("/");
        setTimeout(() => document.location.reload(), 500); // Wipe out GQL cache
    } catch (err) {
        throw new Error('Failed logout.');
    }
}
